import React, { useEffect, useState, useRef } from "react";
import { utilService } from "../../../../services";
import sanitizeHtml from "sanitize-html";
import { AudioService } from "./AudioComponent.service";
import { dataTransferService } from "../../../../services/dataTransferService";
import { doctorsListService } from "../../../../components/Shared/DoctorList/doctor-list-service";
import {
  MediaCapture,
  MediaFile,
  CaptureAudioOptions,
} from "@ionic-native/media-capture";

// import { CameraResultType, Capacitor } from "@capacitor/core";
import { Capacitor } from "@capacitor/core";
import { File as ionicFile } from "@ionic-native/file";
declare const Recorder: any;

interface AudioComponentProps {
  onComplete: () => void;
  selectedDoctorData: object;
  isStatusBoard?: boolean;
  smsThread?: any;
}

const AudioComponent: React.FC<AudioComponentProps> = (props) => {
  const gumStream = useRef<any>();
  const rec = useRef<any>();
  const [status, setStatus] = useState<string | undefined>();
  const [isWeb, setIsWeb] = useState(false);

  useEffect(() => {
    if (utilService.isWeb()) {
      setIsWeb(true);
    }
  }, []);

  useEffect(() => {
    if (rec.current) {
      webRecordingStarted();
    }
  }, [rec.current]);

  useEffect(() => {
    let sub = dataTransferService.getAudioMediaAction.subscribe((data: any) => {
      if (data === true) {
        startRecord();
      } else {
        stopRecord();
      }
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);

  const startRecord = () => {
    if (utilService.isWeb()) {
      webStartRecord();
    } else {
      nativeStartRecord();
    }
  };

  const stopRecord = () => {
    if (utilService.isWeb()) {
      webStopRecord();
    } else {
    }
  };

  const webStartRecord = () => {
    const constraints = { audio: true, video: false };
  
    navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
      gumStream.current = stream;
      const AudioContext = (window as any).AudioContext;
      const audioContext = new AudioContext();
      const input = audioContext.createMediaStreamSource(stream);
  
      rec.current = new Recorder(input, { numChannels: 1 });
  
      // Start recording immediately after setup
      rec.current.record();
      setStatus("Recording started...");
    }).catch((err) => {
      console.error("Error accessing microphone:", err);
    });
  };

  const webRecordingStarted = () => {
    rec.current.record();
    setStatus("test audio Recording started...");
  };

  const webStopRecord = () => {
    if (!rec.current) {
      console.error("No active recording found.");
      return;
    }
  
    rec.current.stop();
    if (gumStream.current) {
      gumStream.current.getAudioTracks()[0].stop();
    }
    
    rec.current.exportWAV(createDownloadLink);
  };

  const createDownloadLink = (blob: Blob) => {
    const fileName =
      "AUD_" +
      new Date().toISOString().slice(0, 10) +
      "_" +
      new Date().toLocaleTimeString() +
      ".mp3";
  
    if (!blob || blob.size === 0) {
      console.error("Empty audio blob");
      return;
    }
  
    const fileData = new File([blob], fileName?.replace(/\s+/g, ''), {
      lastModified: new Date().getTime(),
      type: 'audio/mp3',
    });
    const objectURL = URL.createObjectURL(blob); // Do not sanitize
  
    const audioRecording = {
      name: fileName.replace(/\s+/g, ''),
      type: 2,
      nativeURL: objectURL, // No need to sanitize
      size: utilService.formatBytes(fileData.size),
      file:fileData
    };
  
    console.log("test audio File Data:", fileData);
    console.log("test audio Recording:", audioRecording);
  
    setParams(fileData, audioRecording);
  };

  const nativeStartRecord = async () => {
    let options: CaptureAudioOptions = { limit: 1, duration: 30 };
    let capture: any = await MediaCapture.captureAudio(options);
    if (capture.length > 0) {
      const replacingComma = capture[0].fullPath.split("%2C").join(",");
      const replacingSpace = replacingComma.split("%20").join(" ");
      copyFileToLocalDir(replacingSpace);
    }
  };

  const copyFileToLocalDir = async (fullPath: any) => {
    const name = fullPath.substr(fullPath.lastIndexOf("/") + 1);
    let resolvedPath: any;
    let path = fullPath.substring(0, fullPath.lastIndexOf("/"));
    if (Capacitor.getPlatform() === "ios") {
      resolvedPath = await ionicFile.resolveDirectoryUrl("file://" + path);
    } else {
      resolvedPath = await ionicFile.resolveDirectoryUrl(path);
    }
    readAsArrayBuffer(resolvedPath, name);
  };

  const readAsArrayBuffer = (resolvedPath: any, name: any) => {
    return ionicFile.readAsArrayBuffer(resolvedPath.nativeURL, name).then(
      (buffer: any) => {
        const fileExtension = name.match(/\.[A-z0-9]+$/i)[0].slice(1);
        let blob = new Blob([buffer], {
          type: `audio/${fileExtension}`,
        });
        setFileData(blob, resolvedPath.nativeURL, name, fileExtension);
      },
      (error: any) => console.log(error)
    );
  };

  const setFileData = (Blob: any, path: any, name: any, extn: any) => {
    const fileData = blobToFile(Blob, name);
    const filePath = path + name;
    setNativeParams(fileData, filePath, extn);
  };

  const blobToFile = (theBlob: any, fileName: string): any => {
    var b: any = theBlob;
    b.lastModifiedDate = new Date();
    b.name = fileName;
    return theBlob as any;
  };

  const mapToGuidData = () => {
    if (props.isStatusBoard) {
      var initialArray = [];
      initialArray.push(utilService.getLoggedUserGuid());
      return JSON.stringify(initialArray);
    } else {
      return JSON.stringify(
        doctorsListService.getSelectedUsersList(props.selectedDoctorData)
      );
    }
  };

  const setParams = (fileData: any, audioRecording: any) => {
    let clientMediaID = Math.floor(Math.random() * 10000);
    audioRecording.clientMediaID = clientMediaID;
    const params = {
      clientMediaID: clientMediaID,
      from_guid: utilService.getLoggedUserGuid(),
      to_guid: mapToGuidData(),
      message: "",
      type: 2,
      action: 1,
      sms_thread_id: props.smsThread ? props.smsThread : null,
      name:
        "AUD-" +
        new Date().getDate() +
        new Date().getMonth() +
        new Date().getHours() +
        new Date().getMinutes() +
        new Date().getSeconds() +
        ".mp3",
      file: fileData,
      size: utilService.formatBytes(fileData.size),
    };
    console.log("test audio params setParams",params)
    console.log("test audio params audioRecording",audioRecording)
    AudioService.displayAudioList.push(audioRecording);
    AudioService.uploadAudioList.push(params);
    props.onComplete();
  };

  const setNativeParams = (fileData: any, filePath: any, extn: any) => {
    let clientMediaID = Math.floor(Math.random() * 10000);
    const filename =
      "AUD-" +
      new Date().getDate() +
      new Date().getMonth() +
      new Date().getHours() +
      new Date().getMinutes() +
      new Date().getSeconds() +
      "." +
      extn;
    const serverParams = {
      clientMediaID: clientMediaID,
      from_guid: utilService.getLoggedUserGuid(),
      to_guid: mapToGuidData(),
      message: "",
      type: 2,
      action: 1,
      sms_thread_id: props.smsThread ? props.smsThread : null,
      name: filename,
      file: fileData,
      size: utilService.formatBytes(fileData.size),
    };
    const localParams = {
      clientMediaID: clientMediaID,
      type: 2,
      name: filename,
      nativeURL: filePath,
      size: utilService.formatBytes(fileData.size),
    };
    AudioService.displayAudioList.push(localParams);
    AudioService.uploadAudioList.push(serverParams);
    props.onComplete();
  };

  return <div></div>;
};

export default AudioComponent;
